import React, { useEffect, useState } from "react";
import {
  CommonHeader,
  EmptyListPage,
  ErrorSuccessModal,
  TableLoader,
} from "../../../components/commons";
import { RootState } from "../../../redux/rootReducers";
import { resetSession } from "../../../redux/auth";
import {
  getClientWiseMonthlyTimeSheetReportAction,
  resetClientWiseMonthlyTimesheetReportList,
  resetTimeSheetError,
  resetTimeSheetMessage,
  resetTimesheetReportTargetHours,
  resetTimeSheetStatusCode,
  resetTimeSheetSuccess,
} from "../../../redux/timeSheet";
import { connect } from "react-redux";
import TimesheetClientWiseMonthlyReportHeader from "../../../components/TimeSheetReports/TimesheetClientWiseMonthlyReport/TimesheetClientWiseMonthlyReportHeader";
import { DropDownUserType } from "../TimeSheetSummaryReport";
import { ClientDirectoryListType } from "../../../redux/clientDirectory/clientDirectoryType";
import { GetClientDirectoryListPayloadType } from "../../../commonTypes/clientDirectoryTypes";
import useDebounce from "../../../customHooks/useDebounce";
import { getClientDirectoryListAction } from "../../../redux/clientDirectory";
import { formatDate, handleDate } from "../../../utils/commonFunctions";
import { EmptyTimeSheetReportList } from "../../../assets/images";
import TimesheetClientWiseMonthlyTable from "../../../components/TimeSheetReports/TimesheetClientWiseMonthlyReport/TimesheetClientWiseMonthlyTable";
import { ClientWiseMonthlyTimesheetType } from "../../../redux/timeSheet/timeSheetType";
import { GetClientWiseMonthlyReportPayloadType } from "../../../commonTypes/timeSheetTypes";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { downloadClientWiseMonthlyTimeSheetReportApi } from "../../../apis/timeSheetApis";
import FileSaver from "file-saver";
import toast from "react-hot-toast";
import { Excel } from "../../../components/Icon";
import { useMenuCheck } from "../../../customHooks/useMenuCheck";

type AppProps = {
  token: string | null;
  statusCode: number | null;
  success: number | null;
  error: string | null;
  message: string | null;
  fetching: boolean;
  clientWiseMonthlyTimesheetReportList: ClientWiseMonthlyTimesheetType[]|[];
  clientDirectoryList: [] | ClientDirectoryListType[];
  totalCount: number | null;
  clientWiseMonthlyReportCount: number;
  clientFetching: boolean;
  dispatchResetTimeSheetReportSuccess: () => void;
  dispatchResetTimeSheetReportError: () => void;
  dispatchResetTimeSheetReportMessage: () => void;
  dispatchResetTimeSheetReportStatusCode: () => void;
  dispatchResetSession: () => void;
  dispatchGetClientWiseMonthlyTimeSheetReportAction: (data: GetClientWiseMonthlyReportPayloadType) => void;
  dispatchResetClientWiseMonthlyTimesheetReportList: () => void;
  dispatchGetClientDirectoryListAction: (
    data: GetClientDirectoryListPayloadType
  ) => void;
  dispatchResetTimesheetReportTargetHours:()=>void;
  timesheetReportTargetHours:number;

};
const TimesheetClientWiseMonthlyReport = ({
  token,
  statusCode,
  success,
  error,
  message,
  fetching,
  clientWiseMonthlyReportCount,
  clientWiseMonthlyTimesheetReportList,
  dispatchResetTimeSheetReportSuccess,
  dispatchResetTimeSheetReportError,
  dispatchResetTimeSheetReportMessage,
  dispatchResetTimeSheetReportStatusCode,
  dispatchResetSession,
  dispatchGetClientWiseMonthlyTimeSheetReportAction,
  dispatchResetClientWiseMonthlyTimesheetReportList,
  dispatchGetClientDirectoryListAction,
  clientDirectoryList,
  totalCount,
  clientFetching,
  dispatchResetTimesheetReportTargetHours,
  timesheetReportTargetHours
  
}: AppProps) => {
  const [finalClientList, setFinalClientList] = useState<
    DropDownUserType[] | []
  >([]);
  const [finalClient, setFinalClient] = useState<string>("");
  const [client, setClient] = useState<DropDownUserType>({
    label: "Select...",
    value: null,
  });
  const [data, setData] = useState<ClientWiseMonthlyTimesheetType[] | []>([]);
  const [limit, setLimit] = useState<number>(20);
  const [clientOffset, setClientOffset] = useState(0);
  const [clientText, setClientText] = useState("");
  const [toggle, setToggle] = useState<boolean>(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [currentStartDate, setCurrentStartDate] = useState<string>("");
  const [currentEndDate, setCurrentEndDate] = useState<string>("");

  //====================User Management=============================
  const [isDownloadClientWiseMonthlyReportPresent, setIsDownloadClientWiseMonthlyReportPresent] =
    useMenuCheck();
  const [isGetClientWiseMonthlyReportPresent, setIsGetClientWiseMonthlyReportPresent] =
    useMenuCheck();

  //=================================================================

  useEffect(() => {
    dispatchResetTimeSheetReportSuccess();
    dispatchResetTimeSheetReportError();
    dispatchResetTimeSheetReportMessage();
    dispatchResetTimeSheetReportStatusCode();
    dispatchResetClientWiseMonthlyTimesheetReportList();
    dispatchResetTimesheetReportTargetHours();
    setIsDownloadClientWiseMonthlyReportPresent("Download Client Wise Timesheet Report", "menu")
    setIsGetClientWiseMonthlyReportPresent("Get Client Wise Monthly Timesheet Report","menu")
    window.scrollTo(0, 0);

  }, []);

  useEffect(() => {
    const finalClientListData = clientDirectoryList?.map((data: any) => {
      return {
        value: data?.client_code,
        label: `${data?.company_name}(${data?.client_code})`,
      };
    });
    if (clientOffset > 0) {
      setFinalClientList([...finalClientList, ...finalClientListData]);
    } else {
      setFinalClientList(finalClientListData);
    }
  }, [clientDirectoryList]);

  useEffect(() => {
    if (token && totalCount) {
      if (clientOffset <= +totalCount) {
        const finalData = {
          token,
          // status: 1,
          offset: clientOffset,
          limit: limit,
          searchValue: clientText,
        };
        dispatchGetClientDirectoryListAction(finalData);
      }
    }
  }, [clientOffset]);

  const fetchClientNewData = () => {
    const finalData = {
      token,
      // status: 1,
      offset: clientOffset,
      limit: limit,
      searchValue: clientText,
    };
    dispatchGetClientDirectoryListAction(finalData);
  };

  useDebounce(
    () => {
      if (clientText) {
        fetchClientNewData();
      } else {
        const finalData = {
          token,
          // status: 1,
          offset: clientOffset,
          limit: limit,
          searchValue: clientText,
        };
        dispatchGetClientDirectoryListAction(finalData);
      }
    },
    500,
    [clientText]
  );

  const handleStartDateChange = (date: any) => {
    const value = handleDate(date);
    setStartDate(value);
  };

  const handleEndDateChange = (date: any) => {
    const value = handleDate(date);
    setEndDate(value);
  };
  const handleSubmitData = () => {
    setFinalClient(client?.label?.split("(")[0]);
    dispatchResetClientWiseMonthlyTimesheetReportList();
    setCurrentStartDate(startDate ? formatDate(startDate) : "");
    setCurrentEndDate(endDate ? formatDate(endDate) : "");
    window.scrollTo(0, 0);
    setData([]);
    if (token) {
      let finalData: GetClientWiseMonthlyReportPayloadType = {
        token,
        start_date: startDate ? formatDate(startDate) : "",
        end_date: endDate ? formatDate(endDate) : "",
        client_code: client?.value,
      };
      dispatchGetClientWiseMonthlyTimeSheetReportAction(finalData);
    }
  };

  const handleDownload = (params: any) => {
    let reportName =
      `client_wise_monthly_timesheet_reports(${client?.value})` +
      "_" +
      currentStartDate +
      "_" +
      currentEndDate +
      ".xlsx";
    let finalApi = downloadClientWiseMonthlyTimeSheetReportApi(params);
    finalApi.then((response: any) => {
      let blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=utf-8",
      });
      FileSaver.saveAs(blob, reportName);
      toast.success("Report Downloaded Successfully!", {
        duration: 3000,
      });
    });
  };

  const handlePrepareDownload = () => {
    let params: any = {
      start_date: currentStartDate,
      end_date: currentEndDate,
      client_code: client?.value,
      token,
    };

    if (params && token) {
      handleDownload(params);
    }
  };

  const renderDownloadInvoiceToolTip = (props: any) => {
    return (
      <Tooltip id="button-view-open-item" {...props}>
        Download Report
      </Tooltip>
    );
  };

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetTimeSheetReportError();
            }}
          />
        );
      }
    }
    return false;
  };
  return (
    <div>
      <CommonHeader title="Client Wise Monthly Timesheet Report" />
      <div className="new-table-card">
        <div className="row">
          <div className="col-md-12 pl-2 pr-2 mt-4 mb-4">
            {
              <div>
                <div
                  className=""
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginTop: "-16px",
                    marginBottom: "2px",
                  }}
                >
                  <div
                    style={{ marginTop: "5px", marginLeft: "15px" }}
                    className="mt-0 pt-2"
                  >
                    <span
                      className="ml-3"
                      style={{
                        fontWeight: "500",
                        letterSpacing: "0.34px",
                        fontSize: "16px",
                      }}
                    >
                      Client Wise Monthly Timesheet Report
                    </span>{" "}
                  </div>
                </div>

                {!!clientWiseMonthlyTimesheetReportList?.length ? (
                  <div
                    style={{
                      marginLeft: "33px",
                      color: "#7c8db0",
                      fontSize: "14px",
                    }}
                  >
                    {`Total ${clientWiseMonthlyReportCount} entries found`}
                  </div>
                ) : null}
              </div>
            }

            <TimesheetClientWiseMonthlyReportHeader
              finalClientList={finalClientList}
              client={client}
              setClient={setClient}
              setClientOffset={setClientOffset}
              clientFetching={clientFetching}
              setClientText={setClientText}
              startDate={startDate}
              endDate={endDate}
              handleStartDateChange={handleStartDateChange}
              handleEndDateChange={handleEndDateChange}
              toggle={toggle}
              setToggle={setToggle}
              handleSubmitData={handleSubmitData}
              currentStartDate={currentStartDate}
              currentEndDate={currentEndDate}
              clientWiseMonthlyTimesheetReportList={
                clientWiseMonthlyTimesheetReportList
              }
              token={token}
              isGetClientWiseMonthlyReportPresent={isGetClientWiseMonthlyReportPresent}
            />
          </div>
        </div>

        <div>
          <hr className="mt-1 mb-3" />

          {!!clientWiseMonthlyTimesheetReportList?.length &&
          !!currentStartDate &&
          !!currentEndDate ? (
            <>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div></div>
                <div>
              <h3 className="text-center">{finalClient}</h3>
              
             
            </div>

                <div className=" d-flex justify-content-end mr-5">
                  {isDownloadClientWiseMonthlyReportPresent && (
                    <div className="mt-1">
                      <OverlayTrigger
                        placement="top"
                        delay={{ show: 250, hide: 250 }}
                        overlay={renderDownloadInvoiceToolTip}
                      >
                        <button
                          style={{ border: "none", marginTop: "-12px" }}
                          onClick={handlePrepareDownload}
                        >
                          <Excel />
                        </button>
                      </OverlayTrigger>
                    </div>
                  )
                  }
                </div>
                
              </div>
          
            </>

          ) : null}
        </div>

        <>
          {fetching ? (
            <TableLoader Rows={10} ColumnPerRow={7} />
          ) : clientWiseMonthlyTimesheetReportList?.length > 0 ? (
            <TimesheetClientWiseMonthlyTable
              data={clientWiseMonthlyTimesheetReportList}
            />
          ) : (
            <>
              {!fetching &&
                (!clientWiseMonthlyTimesheetReportList ||
                  clientWiseMonthlyTimesheetReportList?.length === 0) && (
                  <div className="pb-4 pl-0 pr-0">
                    <EmptyListPage
                      title="No List Found!"
                      imageWidth="30%"
                      image={EmptyTimeSheetReportList}
                      showAddButton={false}
                    />
                  </div>
                )}
            </>
          )}
        </>
      </div>
      {handleErrorModal()}

    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  error: state.timeSheet.error,
  statusCode: state.timeSheet.statusCode,
  success: state.timeSheet.success,
  message: state.timeSheet.message,
  fetching: state.timeSheet.fetching,
  clientWiseMonthlyTimesheetReportList:
    state.timeSheet.clientWiseMonthlyTimesheetReportList,
  clientDirectoryList: state.clientDirectory.clientDirectoryList,
  clientFetching: state.clientDirectory.fetching,
  totalCount: state.clientDirectory.totalCount,
  clientWiseMonthlyReportCount: state.timeSheet.clientWiseMonthlyReportCount,
  timesheetReportTargetHours:state.timeSheet.timesheetReportTargetHours
});
const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetTimeSheetReportSuccess: () => dispatch(resetTimeSheetSuccess()),
  dispatchResetTimeSheetReportError: () => dispatch(resetTimeSheetError()),
  dispatchResetTimeSheetReportMessage: () => dispatch(resetTimeSheetMessage()),
  dispatchResetTimeSheetReportStatusCode: () =>
    dispatch(resetTimeSheetStatusCode()),
  dispatchGetClientWiseMonthlyTimeSheetReportAction: (data: GetClientWiseMonthlyReportPayloadType) =>
    dispatch(getClientWiseMonthlyTimeSheetReportAction(data)),
  dispatchResetClientWiseMonthlyTimesheetReportList: () =>
    dispatch(resetClientWiseMonthlyTimesheetReportList()),
  dispatchGetClientDirectoryListAction: (
    data: GetClientDirectoryListPayloadType
  ) => dispatch(getClientDirectoryListAction(data)),
  dispatchResetTimesheetReportTargetHours:()=>dispatch(resetTimesheetReportTargetHours())
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TimesheetClientWiseMonthlyReport);
